import { createI18n } from "vue-i18n";
import spa_en from "../i18n/locales/en.json";
import spa_fr from "../i18n/locales/fr.json";
import vacv_en from "vacv-components/locales/en.json";
import vacv_fr from "vacv-components/locales/fr.json";
import { Locales } from "../../types/tabs";
import { getCurrentLanguage, numberFormat } from "vacv-components";

// merge text copy from vacv-components into this project
// local text overrides the text in vacv-components
const localesMerged = {
  en: { ...vacv_en, ...spa_en },
  fr: { ...vacv_fr, ...spa_fr },
};

const i18n = createI18n({
  legacy: false,
  locale: getCurrentLanguage() || Locales.EN,
  globalInjection: true,
  fallbackLocale: Locales.EN,
  messages: localesMerged,
});
i18n.global.setNumberFormat("en", numberFormat);
i18n.global.setNumberFormat("fr", numberFormat);

export default i18n;
